const OFFER_PAGE_ASSISTANT_SPOOF_AGENT_USER_IDS: ReadonlySet<string> = new Set([
  'cf01cdf4-1019-4641-bf97-843fcd8fae15', // William Ritossa
  '69fbdc21-93a5-47e3-b3c6-2355d47e363b', // Joss Paling
  '309bbbeb-24c1-4929-becd-4e5e67c2b1d9', // Sam Hammond
  '0466a787-047c-4996-9b00-4eebdcc4496f', // James Hilton
  '8c3f4efa-715a-4ee3-a2e9-39139c1c2901', // Alex Jones
  'da1bb2f6-2ae3-42bb-9dd1-2016fc5adfb1', // Akki Dhingra
  '5686e6c1-16e9-47fc-9c18-cc8f6bf3222b', // Darren O'Connor
  'bb64d993-b1a4-4a55-adae-11287bf490cd', // Meg Richards
  'c9465b91-78fa-4bb5-ae74-10c3b0609aeb', // Jack Ross
  '77896825-467e-4222-ad15-588161b7dfe1', // Diellon Lihari
  '19218c89-c320-4b74-bef4-04575e9d1e60', // Emma Ryan-Falcon
  'ddd070be-9155-4aaf-8100-ff718d857ad9', // Koren Sela
  'da2d0733-ac1c-4a79-8f86-e4805365acf7', // Jayden Hunter
])

export function canAlwaysUseOfferPageAssistantInSpoofMode({
  isSpoofed,
  spoofingAgentUserId,
}: {
  isSpoofed: boolean
  spoofingAgentUserId?: string
}): boolean {
  return (
    isSpoofed &&
    !!spoofingAgentUserId &&
    OFFER_PAGE_ASSISTANT_SPOOF_AGENT_USER_IDS.has(spoofingAgentUserId)
  )
}
